import { useQuery } from "@tanstack/react-query";
import { fetchKeywordDetail } from "../lib/api";
export function useKeywordDetailQuery(keyword, options) {
    return useQuery({
        queryKey: ["keyword-detail", keyword],
        enabled: Boolean(keyword) && options?.enabled !== false,
        queryFn: async () => {
            if (!keyword) {
                throw new Error("Keyword required");
            }
            return fetchKeywordDetail(keyword);
        },
        refetchOnMount: true,
        staleTime: 10000
    });
}
